export default __webpack_public_path__ + "static/media/expand_normal.45746c5c.svg";